module.exports = __webpack_public_path__ + "img/createdDate-icon.ccb48596.svg";